import { useContext } from 'react';

import AgronomyAgreementCropsContext from './AgronomyAgreementCropsContext';

const useAgronomyAgreementCrops = () => {
  return useContext(AgronomyAgreementCropsContext);
};

export default useAgronomyAgreementCrops;
